import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function AdminSettings() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Admin Settings
      </Typography>
      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="body1">
          Settings content will go here
        </Typography>
      </Paper>
    </Box>
  );
}

export default AdminSettings;

